import { clienteAxios, updateHeader } from "../config/axios"
import { history } from "../helpers/history"
import { axios } from "axios"
import { authHeader } from "../helpers/auth-header"
import { clearLocalStorage } from "../utils"
export const userService = {
	login,
	logoutUser,
	loginAzure,
	getUserList,
}

const qs = require("qs")

function login(username, password) {
	return clienteAxios
		.post("/auth/token", qs.stringify({ username: username, password: password }))
		.then((user) => {
			//Verificar los datos que envía la API
			if (user.data.token.access_token !== undefined) {
				localStorage.setItem("user", JSON.stringify(user.data))
				//updateHeader();
			}
			return user.data
		})
		.catch((error) => {
			if (error.response.status === 403) {
				return error.response.data
			}
		})
}

function loginAzure(oid, name, username) {
	try {
		return clienteAxios
			.post("/get-token", { user_id: oid, name: name, username: username })
			.then((user) => {
				if (user.data.auth_token !== undefined) {
					localStorage.setItem("user", JSON.stringify(user.data))
					updateHeader()
				}
				return user.data
			})
			.catch((error) => {
				if (error.response.status === 403) {
					return error.response.data
				}
			})
	} catch (e) {
		history.push("/login-error")
	}
}

function logoutUser() {
	// Este endpoint no existe en la nueva API
	// clienteAxios.get('/logout',{},{"headers": authHeader()});
	clearLocalStorage()
}

function getUserList() {
	return clienteAxios.get("/user", {}, { headers: authHeader() }).then((userList) => {
		return userList
	})
}
